import {ArchivedUserInfo} from '../archived-proposal/archived-user-info';
import {Country} from '../country';
import {UserInfo} from '../proposal';
import {Province} from '../province';

export const MOCK_USER_INFO: UserInfo = {
  firstName: 'John',
  lastName: 'Doe',
  languageCode: 'en',
  email: 'dev@emma.ca',
  phone: '5145555555',
  address: '1234 rue de la rue',
  unitNumber: '101',
  city: 'Montréal',
  province: Province.ON,
  postalCode: 'H1H1H1',
  birthCountry: Country.CA,
  birthState: Province.QC,
};

export const MOCK_ARCHIVED_USER_INFO: ArchivedUserInfo = {
  firstName: 'John',
  lastName: 'Doe',
  languageCode: 'en',
  email: 'dev@emma.ca',
  phone: '5145555555',
  address: '1234 rue de la rue',
  unitNumber: '101',
  city: 'Montréal',
  province: Province.ON,
  postalCode: 'H1H1H1',
  birthCountry: Country.CA,
  birthState: Province.QC,
};
